module.exports = __webpack_public_path__ + "media/images/l-white-1f8c9c03b92dfd60358fd474bb30134f.png";